import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { Button } from '../ui/button';
import { API } from '../../App';
import axios from 'axios';
import { toast } from 'sonner';

export function StandSidesDialog({ open, onOpenChange, stand, onUpdate }) {
  const [sides, setSides] = useState({
    A: 'açık', B: 'açık', C: 'açık', D: 'açık'
  });

  useEffect(() => {
    if (stand?.sides) {
      setSides({ A: 'açık', B: 'açık', C: 'açık', D: 'açık', ...stand.sides });
    } else {
      setSides({ A: 'açık', B: 'açık', C: 'açık', D: 'açık' });
    }
  }, [stand]);

  const toggleSide = (side) => {
    setSides(prev => ({
      ...prev,
      [side]: prev[side] === 'açık' ? 'kapalı' : 'açık'
    }));
  };

  const saveSides = async () => {
    try {
      const token = localStorage.getItem('token');
      await axios.patch(`${API}/stands/${stand.id}`, { sides }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Kenar ayarları kaydedildi');
      onUpdate();
      onOpenChange(false);
    } catch {
      toast.error('Kenar ayarları kaydedilemedi');
    }
  };

  if (!stand) return null;

  const sideStyle = (side) =>
    sides[side] === 'kapalı'
      ? 'bg-gray-800 text-white border-gray-900 shadow-inner'
      : 'bg-emerald-50 text-emerald-700 border-emerald-400 hover:bg-emerald-100';

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xs" data-testid="sides-dialog">
        <DialogHeader>
          <DialogTitle className="text-base">Kenar Yapılandırma</DialogTitle>
          <DialogDescription className="text-xs">
            Stand {stand.stand_number || '?'} — Her kenarı tıklayarak açık/kapalı ayarlayın
          </DialogDescription>
        </DialogHeader>

        <div className="flex flex-col items-center gap-1.5 py-3">
          {/* A = Üst */}
          <button
            onClick={() => toggleSide('A')}
            data-testid="side-A-btn"
            className={`w-36 h-7 rounded border-2 text-xs font-semibold transition-all ${sideStyle('A')}`}
          >
            A (Üst) — {sides.A === 'kapalı' ? 'Kapalı' : 'Açık'}
          </button>

          <div className="flex items-center gap-1.5">
            {/* D = Sol */}
            <button
              onClick={() => toggleSide('D')}
              data-testid="side-D-btn"
              className={`w-7 h-20 rounded border-2 text-[10px] font-semibold transition-all flex items-center justify-center ${sideStyle('D')}`}
              style={{ writingMode: 'vertical-rl' }}
            >
              D {sides.D === 'kapalı' ? '✕' : '○'}
            </button>

            {/* Stand center */}
            <div className="w-24 h-20 bg-slate-100 border-2 border-slate-300 rounded flex items-center justify-center">
              <span className="text-xs font-medium text-slate-500">{stand.stand_number || 'Stand'}</span>
            </div>

            {/* B = Sağ */}
            <button
              onClick={() => toggleSide('B')}
              data-testid="side-B-btn"
              className={`w-7 h-20 rounded border-2 text-[10px] font-semibold transition-all flex items-center justify-center ${sideStyle('B')}`}
              style={{ writingMode: 'vertical-rl' }}
            >
              B {sides.B === 'kapalı' ? '✕' : '○'}
            </button>
          </div>

          {/* C = Alt */}
          <button
            onClick={() => toggleSide('C')}
            data-testid="side-C-btn"
            className={`w-36 h-7 rounded border-2 text-xs font-semibold transition-all ${sideStyle('C')}`}
          >
            C (Alt) — {sides.C === 'kapalı' ? 'Kapalı' : 'Açık'}
          </button>
        </div>

        <div className="flex gap-3 text-[10px] text-gray-500 justify-center">
          <span className="flex items-center gap-1">
            <span className="w-2.5 h-2.5 rounded-sm bg-emerald-50 border border-emerald-400"></span> Açık
          </span>
          <span className="flex items-center gap-1">
            <span className="w-2.5 h-2.5 rounded-sm bg-gray-800 border border-gray-900"></span> Kapalı
          </span>
        </div>

        <div className="flex gap-2 mt-2">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            className="flex-1"
            data-testid="sides-cancel-btn"
          >
            Vazgeç
          </Button>
          <Button
            onClick={saveSides}
            className="flex-1"
            data-testid="sides-save-btn"
          >
            Kaydet
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
